import { render, staticRenderFns } from "./ModalCreateSpace.vue?vue&type=template&id=7f50f9aa"
import script from "./ModalCreateSpace.vue?vue&type=script&lang=js"
export * from "./ModalCreateSpace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports